import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import { RadioButton } from 'components-ref/atoms'
import { Tabs as TabsType } from 'types/enums/analytics/content/sort/Tabs'
import { AnalyticsContentModalSortBy } from 'types/interfaces/IContentModalSortFilter'

interface IProps {
    tab: TabsType
    sortByValue: AnalyticsContentModalSortBy | ''
    setSortBy: (value: AnalyticsContentModalSortBy | '') => void
    activeTab?:any
}

export const AnalyticsContentModalOptions = ({
    tab,
    sortByValue,
    activeTab,
    setSortBy
}: IProps) => {
    const { t } = useTranslation()
    const salesTabOptions = [
        {
            name: t('overallRevenue'),
            value: AnalyticsContentModalSortBy.overall_revenue,
            showInTabs: ['feed', 'premium', 'messages', 'stories']
        },
        { name: t('tips'), value: AnalyticsContentModalSortBy.tips,showInTabs: ['feed', 'premium', 'messages', 'stories'] },
        { name: t('purchases'), value: AnalyticsContentModalSortBy.purchases,showInTabs: ['feed', 'premium', 'messages'] },
        { name: t('tip_quantity'), value: AnalyticsContentModalSortBy.tip_quantity, showInTabs: ['feed', 'premium', 'messages', 'stories'] },
        { name: t('purchase_quantity'), value: AnalyticsContentModalSortBy.purchase_quantity, showInTabs: ['feed', 'premium', 'messages'] },
    ]

    const filteredSalesTabOptions = salesTabOptions.filter(option =>
        option.showInTabs.includes(activeTab)
    );

    const analyticsTabOptions = [
        {
            name: t('date_published'),
            value: AnalyticsContentModalSortBy.date_published,
            showInTabs: ['feed', 'premium', 'messages', 'stories']
        },
        {
            name: t('mediaViews'),
            value: AnalyticsContentModalSortBy.media_views,
            showInTabs: ['feed', 'premium', 'messages', 'stories']
        },
        {
            name: t('impressions'),
            value: AnalyticsContentModalSortBy.impressions,
            showInTabs: ['feed', 'premium',]
        },
        {
            name: t('videoCompletionRate'),
            value: AnalyticsContentModalSortBy.videoCompletionRate,
            showInTabs: ['feed', 'premium', 'messages']
        },
        {
            name: t('purchaseRate'),
            value: AnalyticsContentModalSortBy.purchaseRate,
            showInTabs: [ 'messages']
        },
        {
            name: t('mediaViewsImpressionRate'),
            value: AnalyticsContentModalSortBy.media_views_impression_rate,
            showInTabs: ['feed']
        },
        {
            name: t('purchaseImpressionRate'),
            value: AnalyticsContentModalSortBy.purchase_impression_rate,
            showInTabs: ['feed', 'premium']
        },
        {
            name: t('EngagmentRate'),
            value: AnalyticsContentModalSortBy.engagement_rate,
            showInTabs: ['feed', 'premium']
        }
    ]

    const filteredAnalyticsTabOptions = analyticsTabOptions.filter(option =>
        option.showInTabs.includes(activeTab)
    );
    const engagementTabOptions = [
        { name: t('likes'), value: AnalyticsContentModalSortBy.likes ,showInTabs: ['feed', 'premium', 'messages', 'stories']},
        { name: t('comments'), value: AnalyticsContentModalSortBy.comments ,showInTabs: ['feed', 'premium']}
    ]

    const filteredEngagementTabOptions = engagementTabOptions.filter(option =>
        option.showInTabs.includes(activeTab)
    );

    const sortByMap = {
        [TabsType.SALES]: filteredSalesTabOptions,
        [TabsType.ANALYTICS]: filteredAnalyticsTabOptions,
        [TabsType.ENGAGEMENT]: filteredEngagementTabOptions
    }

    return (
        <ButtonsContainer>
            {sortByMap[tab].map((item, index) => (
                <FilterContainer
                    key={index}
                    onClick={e => {
                        e.stopPropagation()
                        setSortBy(sortByValue === item.value ? '' : item.value)
                    }}
                >
                    {item.name}
                    <RadioButton active={sortByValue === item.value} />
                </FilterContainer>
            ))}
        </ButtonsContainer>
    )
}

const ButtonsContainer = styled.div`
    & > * + * {
        margin-top: 1rem;
    }
`

const FilterContainer = styled.div`
    display: flex;
    justify-content: space-between;
    gap: 1rem;
    cursor: pointer;
    margin-top: 2rem;

    font-size: 14px;
    font-weight: 600;
    line-height: 17.07px;
    text-align: left;
`
